import MPAAdminMemos from './MPAAdminMemos';

export default MPAAdminMemos;
